import { render, staticRenderFns } from "./Stickers.vue?vue&type=template&id=451c8640&scoped=true&"
import script from "./Stickers.vue?vue&type=script&lang=js&"
export * from "./Stickers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451c8640",
  null
  
)

export default component.exports